import { VERIFICATION_STATE_COPY } from "./provenance.constants.ts";
import type { VerificationState } from "./provenance.model.ts";

/**
 * What the record holds about this link, where it is being read.
 *
 * The panel that replaced four buttons on the work record. Everything here is a
 * statement about what has already happened — who has put their name to it,
 * whether anyone disagrees, what you yourself said, who has been asked. Nothing
 * asks the reader to do anything, and nothing concludes: the counts are the
 * counts, and this registry does not decide between people who disagree.
 *
 * Who and when is listed above by `ProvenanceConfirmations`; this summarises
 * and adds the two things that were previously visible only on a button's
 * tooltip or nowhere at all.
 */
export function ProvenanceVerificationState({ state }: { state: VerificationState }) {
  return (
    <section className="provenance__subcard">
      <h4 className="provenance__subcard-title">{VERIFICATION_STATE_COPY.title}</h4>

      <p className="provenance__standing">{state.standing}</p>

      {state.caveat !== null && (
        <p className="provenance__help provenance__help--contested">{state.caveat}</p>
      )}

      {state.yours !== null && <p className="provenance__taken">{state.yours}</p>}

      {state.asked !== null && (
        <div className="provenance__asked">
          <h5 className="provenance__asked-title">{VERIFICATION_STATE_COPY.askedTitle}</h5>
          <p className="provenance__standing">{state.asked.summary}</p>

          {/* Empty until the fetch lands, and empty is not "nobody" — the
              summary above already says how many, off a count that arrived
              with the chain. */}
          {state.asked.rows.length > 0 && (
            <ul className="provenance__asks">
              {state.asked.rows.map((row) => (
                <li key={row.id} className="provenance__ask">
                  <span className="provenance__ask-who">{row.who}</span>
                  <span className="provenance__ask-when">{row.when}</span>
                  <span className="provenance__ask-status">{row.status}</span>
                </li>
              ))}
            </ul>
          )}

          <p className="provenance__help">{state.asked.note}</p>
        </div>
      )}
    </section>
  );
}
